import React, { useContext, useEffect, useState } from 'react';
import Toast from 'monday-ui-react-core/dist/Toast';
import { FileContext } from '../../context/FileContext';
import { useTranslation } from 'react-i18next';

const SuccessToast = () => {
  const { successToastMessage, triggerSuccessToast } = useContext(FileContext);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (successToastMessage) {
      setShowSuccessToast(true);
    }
  }, [successToastMessage]);

  const handleClose = () => {
    setShowSuccessToast(false);
    triggerSuccessToast(null);
  };

  return (
    <Toast
      className="monday-storybook-toast_wrapper z-index-max"
      open={showSuccessToast}
      autoHideDuration={3000}
      type={Toast.types.POSITIVE}
      onClose={handleClose}
    >
      {t(successToastMessage)}
    </Toast>
  );
};

export default SuccessToast;
